import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Drawer from '@material-ui/core/Drawer';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import green from '@material-ui/core/colors/green';
import { withStyles } from '@material-ui/core/styles';
import Notifier, { openSnackbar } from './notifier';
import AddVideo from './Video/Add';
import ViewVideo from './viewVideo';
import S3Selector from './Video/S3Selector';

import DeleteIcon from '@material-ui/icons/Delete'

import api from '../api/backend';
import confirm from './confirm';

const styles = theme => ({
    paper: {
        margin: theme.spacing.unit * 2,
        padding: theme.spacing.unit * 2,
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flexGrow: 1,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    drawer: {
        width: 500
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

// const videos = [1, 2, 3, 4, 5]

class VideoEditor extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { videos: [], title: '', description: '', path: '', deactivated: false, duration: 0, show: false, file: {}, loading: false, selectedVideo: {} }
    }

    fancyTimeFormat(time) {
        // Hours, minutes and seconds
        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    fancyTimeFormat2(videos) {
        let time = 0;
        videos.forEach(element => {
            time += element.duration
        });
        // Hours, minutes and seconds
        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;

        if (hrs > 0) {
            return `${hrs} ชั่วโมง ${mins} นาที`;
        } else {
            return `${mins} นาที ${secs} วินาที`;
        }
    }

    getVideos = () => {
        const { courseId } = this.props
        api.getVideos(courseId).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ videos: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์ส ${courseId} ได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    uploadVideo = (event) => {
        event.preventDefault();
        const { title, description, duration, file, selectedVideo } = this.state
        this.setState({ loading: true })
        if (duration > 0) {
            api.uploadOverrideVideo(selectedVideo.id, file, title, description, Math.round(duration)).then(([response, json]) => {
                if (response.status === 200) {
                    console.log(json)
                    openSnackbar({ message: 'อับโหลดวีดีโอสำเร็จ' })
                    this.getVideos()
                    this.closeAndClear()
                } else {
                    console.error('อับโหลดวีดีโอไม่สำเร็จ')
                    openSnackbar({ message: 'อับโหลดวีดีโอไม่สำเร็จ' })
                }
            }).catch(() => {
                console.error('ไม่สามารถเชื่อมต่อ service ได้')
                openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
            })
        } else {
            api.updateVideo(selectedVideo.id, { title, description }).then(([response, json]) => {
                if (response.status === 200) {
                    console.log(json)
                    openSnackbar({ message: 'อับเดทวีดีโอสำเร็จ' })
                    this.getVideos()
                    this.closeAndClear()
                } else {
                    console.error('อับเดทวีดีโอไม่สำเร็จ')
                    openSnackbar({ message: 'อับเดทวีดีโอไม่สำเร็จ' })
                }
            }).catch(() => {
                console.error('ไม่สามารถเชื่อมต่อ service ได้')
                openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
            })
        }
    }

    updateVideo = (event) => {
        event.preventDefault();
        const { title, description, path, selectedVideo } = this.state
        api.updateVideo(selectedVideo.id, { title, description, path: encodeURI(path) }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                openSnackbar({ message: 'อับเดทวีดีโอสำเร็จ' })
                this.getVideos()
                this.closeAndClear()
            } else {
                console.error('อับเดทวีดีโอไม่สำเร็จ')
                openSnackbar({ message: 'อับเดทวีดีโอไม่สำเร็จ' })
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
        })
    }

    deleteVideo = (video) => {
        confirm(`ต้องการลบวีดีโอ '${video.title}' ใช่หรือไม่?`).then(
            (result) => {
                api.deleteVideo(video.id).then(([response, json]) => {
                    if (response.status === 200) {
                        console.log(json)
                        openSnackbar({ message: 'ลบวีดีโอสำเร็จ' })
                        this.getVideos()
                        this.closeAndClear()
                    } else {
                        console.error('ลบวีดีโอไม่สำเร็จ')
                        openSnackbar({ message: 'ลบวีดีโอไม่สำเร็จ' })
                    }
                }).catch(() => {
                    console.error('ไม่สามารถเชื่อมต่อ service ได้')
                    openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
                })
            },
            (result) => { }
        )
        
    }

    closeAndClear = () => {
        this.setState({ title: '', description: '', path: '', deactivated: false, duration: 0, show: false, file: {}, loading: false })
    }

    onVideoUploadCompleted = () => {
        this.getVideos()
    }

    componentDidMount() {
        this.getVideos()
    }

    render() {
        const { classes, courseId } = this.props
        const { videos, title, description, deactivated, loading, path } = this.state

        videos.sort(function (a, b) {
            var nameA = a.title.trim().toUpperCase(); // ignore upper and lowercase
            var nameB = b.title.trim().toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        })

        console.log(videos)
        return (
            <div>
                <AddVideo courseId={courseId} onUploadCompleted={this.onVideoUploadCompleted} />
                <Typography variant="subheading" color="textPrimary">
                    เนื้อหา {videos.length} วีดีโอ | ความยาว {this.fancyTimeFormat2(videos)}
                </Typography>
                <br />
                <Drawer anchor="right" open={this.state.show} classes={{
                    paper: classes.drawer,
                }} onClose={() => { this.setState({ title: '', description: '', deactivated: false, show: false, file: {}, loading: false }) }}>

                    <Notifier />
                    <Card className={classes.card}>
                        <CardHeader
                            title={<Typography variant="title" gutterBottom>
                                เพิ่มวีดีโอ
                            </Typography>} />
                        <CardContent className={classes.cardContent}>
                            <form className={classes.form} onSubmit={this.updateVideo}>
                                <Grid container spacing={24}>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="title"
                                            name="title"
                                            label="หัวข้อ"
                                            fullWidth
                                            autoComplete="course title"
                                            value={title}
                                            onChange={(event) => { this.setState({ title: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="description"
                                            name="description"
                                            label="รายละเอียด"
                                            fullWidth
                                            multiline
                                            rows={5}
                                            autoComplete="course description"
                                            value={description}
                                            onChange={(event) => { this.setState({ description: event.target.value }) }}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                        <FormControlLabel
                                            control={<Checkbox color="secondary" name="deactivated" value={`${deactivated}`}
                                                onChange={(event) => { this.setState({ deactivated: event.target.value }) }} />}
                                            label="ยกเลิกวีดีโอ"
                                        />
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        {/* <TextField
                                            id="path"
                                            name="path"
                                            label="Path"
                                            fullWidth
                                            autoComplete="course path"
                                            value={path}
                                            onChange={(event) => { this.setState({ path: event.target.value }) }}
                                        /> */}
                                        <S3Selector selected={path} onCompleted={(value) => { if (value) this.setState({ path: value.value }) }} />
                                    </Grid>
                                    {/* <Grid item xs={6}>
                                        <input
                                            accept="video/mp4"
                                            style={{ display: 'none' }}
                                            id="outlined-button-file"
                                            type="file"
                                            onChange={(event) => {
                                                var video = document.createElement('video');
                                                video.preload = 'metadata';

                                                video.onloadedmetadata = () => {
                                                    var duration = video.duration;
                                                    this.setState({ duration: duration })
                                                }

                                                video.src = URL.createObjectURL(event.target.files[0]);
                                                console.log(event.target.files[0])
                                                this.setState({
                                                    file: event.target.files[0]
                                                })
                                            }}
                                        />
                                        <label htmlFor="outlined-button-file">
                                            <Button variant="outlined" component="span" fullWidth size="large">
                                                เลือกไฟล์วีดีโอ
                                            </Button>
                                        </label>
                                        <br /> <br /> <br />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            id="fileName"
                                            name="fileName"
                                            label="ไฟล์ที่เลือก"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            disabled={true}
                                            value={file.name}
                                        />
                                    </Grid> */}
                                </Grid>
                                <div className={classes.wrapper}>
                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="primary"
                                        disabled={loading}
                                        className={classes.submit}
                                        size="large"
                                        fullWidth
                                    >
                                        บันทึก
                                    </Button>
                                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </div>
                            </form>
                        </CardContent>
                    </Card>
                </Drawer>
                {videos.map(video => (<Paper className={classes.paper} elevation={1} key={video.id}>
                    <Grid container wrap="nowrap" spacing={16}>
                        <ViewVideo videoId={video.id} path={video.path} title={video.title} viewOnly={true} duration={video.duration} />
                        <Grid item xs onClick={() => {
                            this.setState({
                                title: video.title, description: video.description, path: video.path,
                                deactivated: video.deactivated, show: true, selectedVideo: video
                            })
                        }}>
                            <Typography component="p">
                                {video.title}
                            </Typography>
                        </Grid>
                        <Grid item >
                         <DeleteIcon onClick={() => this.deleteVideo(video)}/>
                            {/* <Typography variant="caption">{this.fancyTimeFormat(video.duration)}</Typography> */}
                        </Grid>
                    </Grid>
                </Paper>))}
            </div>
        );
    }
}

export default withStyles(styles)(VideoEditor);